import { gql } from '@apollo/client';

export const GET_GROUP_OPTIONS = gql`
  query GetGroupOptions($input: GroupOptionsInput!) {
    groupOptions: getGroupOptions(input: $input) {
      id
      name
      optionCode
      startDate
      endDate
      status
      clientClassification
    }
  }
`;
